// extracted by mini-css-extract-plugin
export default {"modal":"jQ-z","modalOverlay":"kQ-z","outfitHeading":"lQ-z"};